export default __webpack_public_path__ + "static/media/ic_glp_24.eff381d9.svg";